module.exports = __webpack_public_path__ + "static/media/gd.084d4063.svg";